<template>
  <div class="bts-block bts">
    <button @click="$emit('reset')" class="bt--reset"><span id="btn_save_reset">{{$t("bts.reset")}}</span></button>
    <button @click="$emit('save')" class="bt--submit" :disabled="status"><span id="btn_save__save">{{$t("bts.save")}}</span></button>
  </div>
</template>

<script>
export default {
  name: 'AppBtnSave',
  props: ["disable"],
  data() {
    return {
      status: this.disable || false
    }
  },
  watch:{
    "disable":{
      handler(e) {
        this.status = e
      }
    }
  }
}
</script>
